import { Injectable } from '@angular/core';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { HttpClient } from '@angular/common/http';
import { FacilityMinimumWage } from '../models/facility-minimum-wage.model';
import { Observable } from 'rxjs';
import { combine } from 'src/app/shared/utilities/route';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';

@Injectable({
    providedIn: 'root'
})
export class FacilityMinimumWageService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    getMinimumWage(facilityId: number, startDate: Date): Observable<FacilityMinimumWage> {
        const url = combine(this.coreApiPath, 'minimum-wage/facility');
        const params = interpolateParams({ facilityId, startDate });
        return this._http.get<FacilityMinimumWage>(url, { params });
    }
}
